/* Popups for sections/np-popup.liquid. No discount codes.
   Storage (every read/write wrapped; blocked storage only means a popup may show again):
     sessionStorage np-pop-welcome-seen  '1'        welcome shown this session
     sessionStorage np-pop-welcome-at    timestamp  when it was shown (the exit reminder waits after it)
     localStorage   np-pop-welcome-until timestamp  closed: quiet for 7 days; signed up: quiet for a year
     sessionStorage np-pop-exit-seen     '1'        exit reminder shown this session
   Motion: transform/opacity in np-popup.css; prefers-reduced-motion drops it. */
(() => {
  const welcome = document.querySelector('[data-np-pop="welcome"]');
  const exit = document.querySelector('[data-np-pop="exit"]');
  if (!welcome && !exit) return;

  const K_SEEN = 'np-pop-welcome-seen';
  const K_AT = 'np-pop-welcome-at';
  const K_UNTIL = 'np-pop-welcome-until';
  const K_EXIT = 'np-pop-exit-seen';
  const DAY = 86400000;
  const QUIET_MS = 7 * DAY;
  const DONE_MS = 365 * DAY;
  const SCROLL_TRIGGER = 0.5;
  const RETRY_MS = 4000;
  const CLOSE_MS = 320;
  const EXIT_ARM_MS = 8000;
  const EXIT_AFTER_WELCOME_MS = 3 * 60000;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const designMode = Boolean(window.Shopify && window.Shopify.designMode);
  const html = document.documentElement;

  const storage = {
    get(area, key) {
      try { return window[area].getItem(key); } catch (e) { return null; }
    },
    set(area, key, value) {
      try { window[area].setItem(key, value); } catch (e) { /* blocked storage: nothing to remember */ }
    },
  };

  let current = null;
  let lastFocus = null;

  /* Never over the cart drawer, the menu drawer or another modal. */
  function blocked() {
    if (current) return true;
    if (document.querySelector('cart-drawer.active, cart-notification.active, .quick-add-modal[open], details.menu-opening')) return true;
    return Array.from(document.body.classList).some((c) => c.indexOf('overflow-hidden') === 0);
  }

  function focusables(root) {
    return Array.from(root.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]):not([disabled]), textarea, select, [tabindex]:not([tabindex="-1"])'))
      .filter((el) => el.getClientRects().length > 0);
  }

  function onKey(e) {
    if (!current) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      hide();
      return;
    }
    if (e.key !== 'Tab') return;
    const items = focusables(current.querySelector('.np-pop__card'));
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (e.shiftKey && (document.activeElement === first || !current.contains(document.activeElement))) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function lock(on) {
    if (on) {
      const gap = window.innerWidth - html.clientWidth;
      if (gap > 0) document.body.style.paddingRight = `${gap}px`;
      html.classList.add('np-pop-lock');
    } else {
      html.classList.remove('np-pop-lock');
      document.body.style.paddingRight = '';
    }
  }

  function show(root, focusEl) {
    if (current) return false;
    current = root;
    lastFocus = document.activeElement;
    root.hidden = false;
    lock(true);
    requestAnimationFrame(() => requestAnimationFrame(() => root.classList.add('is-open')));
    document.addEventListener('keydown', onKey);
    const card = root.querySelector('.np-pop__card');
    /* Focus the dialog, not the email field: on phones a focused field opens the keyboard over the sheet. */
    setTimeout(() => (focusEl || card).focus({ preventScroll: true }), reduced ? 0 : 60);
    return true;
  }

  function hide() {
    if (!current) return;
    const root = current;
    current = null;
    root.classList.remove('is-open');
    document.removeEventListener('keydown', onKey);
    lock(false);
    setTimeout(() => { root.hidden = true; }, reduced ? 0 : CLOSE_MS);
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
    root.dispatchEvent(new CustomEvent('np:pop-closed'));
  }

  [welcome, exit].forEach((root) => {
    if (!root) return;
    root.addEventListener('click', (e) => {
      if (e.target.closest('[data-np-pop-close]')) hide();
    });
  });

  /* ---------- Welcome: free cheat sheet ---------- */
  function initWelcome() {
    if (!welcome) return;
    const success = welcome.querySelector('[data-np-pop-success]');
    const error = welcome.querySelector('[data-np-pop-error]');

    welcome.addEventListener('np:pop-closed', () => {
      if (!success) storage.set('localStorage', K_UNTIL, String(Date.now() + QUIET_MS));
    });

    if (designMode) {
      document.addEventListener('shopify:section:select', (e) => {
        if (e.detail && e.detail.sectionId === welcome.dataset.sectionId) show(welcome);
      });
      document.addEventListener('shopify:section:deselect', (e) => {
        if (e.detail && e.detail.sectionId === welcome.dataset.sectionId) hide();
      });
      return;
    }

    /* Back from the signup POST: open straight on the thank-you or the error. */
    if (success || error) {
      storage.set('sessionStorage', K_SEEN, '1');
      if (success) storage.set('localStorage', K_UNTIL, String(Date.now() + DONE_MS));
      show(welcome, success ? welcome.querySelector('.np-pop__title') : welcome.querySelector('input[type="email"]'));
      return;
    }

    const quietUntil = Number(storage.get('localStorage', K_UNTIL)) || 0;
    if (storage.get('sessionStorage', K_SEEN) || Date.now() < quietUntil) return;

    let fired = false;
    const fire = () => {
      if (fired) return;
      if (blocked()) {
        setTimeout(fire, RETRY_MS);
        return;
      }
      fired = true;
      window.removeEventListener('scroll', onScroll);
      storage.set('sessionStorage', K_SEEN, '1');
      storage.set('sessionStorage', K_AT, String(Date.now()));
      show(welcome);
    };
    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 0 && window.scrollY / max >= SCROLL_TRIGGER) fire();
    };
    const delay = Math.max(5, Number(welcome.dataset.delay) || 25) * 1000;
    setTimeout(fire, delay);
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Exit reminder: desktop, empty cart, once per session ---------- */
  function initExit() {
    if (!exit || designMode) return;
    if (!window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 900px)').matches) return;
    if (storage.get('sessionStorage', K_EXIT)) return;
    const parts = String(exit.dataset.end || '').split('-').map(Number);
    if (parts.length !== 3 || parts.some((n) => !n)) return;
    const endDay = new Date(parts[0], parts[1] - 1, parts[2]);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const days = Math.round((endDay - today) / 86400000);
    if (days < 0) return;

    const title = exit.querySelector('[data-np-exit-title]');
    if (title) {
      const name = title.dataset.name || 'The sale';
      if (days === 0) title.textContent = `${name} ends today`;
      else if (days === 1) title.textContent = `${name} ends tomorrow`;
      else title.textContent = `${name} ends in ${days} days`;
    }

    const cartEmpty = () => {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) return drawer.classList.contains('is-empty');
      return !document.querySelector('.cart-count-bubble');
    };
    const welcomeJustShown = () => {
      if (welcome && !welcome.hidden) return true;
      const at = Number(storage.get('sessionStorage', K_AT)) || 0;
      return at > 0 && Date.now() - at < EXIT_AFTER_WELCOME_MS;
    };

    const onOut = (e) => {
      if (e.relatedTarget || e.clientY > 0) return;
      if (storage.get('sessionStorage', K_EXIT) || blocked() || welcomeJustShown() || !cartEmpty()) return;
      storage.set('sessionStorage', K_EXIT, '1');
      document.removeEventListener('mouseout', onOut);
      show(exit);
    };
    setTimeout(() => document.addEventListener('mouseout', onOut), EXIT_ARM_MS);
  }

  const start = () => { initWelcome(); initExit(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
